import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Navigation, Thumbs, Autoplay, FreeMode } from 'swiper';

SwiperCore.use([Navigation, Thumbs, Autoplay, FreeMode]);

@Component({
  selector: 'app-item-slider',
  templateUrl: './item-slider.component.html',
  styleUrls: ['./item-slider.component.scss'],
})
export class ItemSliderComponent implements OnInit, AfterViewInit, OnDestroy {
  // BUG FIX: previously only the thumbnail strip swiper had a ViewChild ref,
  // and the nav buttons called slideNext/slidePrev on IT instead of the main
  // gallery swiper. Thumbs module only syncs main -> thumbs automatically,
  // so the big image never advanced.
  @ViewChild('swiperMain', { static: false }) swiperMain?: SwiperComponent;
  @ViewChild('swiperSecondary', { static: false }) swiperSecondary?: SwiperComponent;

  // Wraps the whole component so we can watch its size (e.g. when it sits
  // inside a CSS Grid column that resolves its width after Swiper first
  // measures, leaving Swiper stuck thinking it has 0 width).
  @ViewChild('galleryRoot', { static: false }) galleryRoot?: ElementRef<HTMLElement>;

  @Input() slides: any[] = [];

  public thumbsSwiper: any = null;
  public activeIndex = 0;

  private resizeObserver?: ResizeObserver;

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    // Swiper measures its container's offsetWidth on init. If the parent
    // CSS Grid column hasn't resolved its final width yet at that exact
    // moment (common with sticky siblings / custom-element hosts that
    // default to display:inline), Swiper locks in a 0px width and never
    // looks again on its own. ResizeObserver tells us whenever the real
    // size changes so we can force Swiper to re-measure with .update().
    if (typeof ResizeObserver !== 'undefined' && this.galleryRoot) {
      this.resizeObserver = new ResizeObserver(() => {
        this.swiperMain?.swiperRef?.update();
        this.swiperSecondary?.swiperRef?.update();
      });
      this.resizeObserver.observe(this.galleryRoot.nativeElement);
    }

    // Also do one deferred update after the current change-detection /
    // layout cycle finishes, which covers browsers without ResizeObserver.
    setTimeout(() => {
      this.swiperMain?.swiperRef?.update();
      this.swiperSecondary?.swiperRef?.update();
    });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  onMainReady(e: any): void {
    // Extra safety: force one update right after Swiper mounts.
    const swiper = Array.isArray(e) ? e[0] : e;
    swiper?.update?.();
  }

  /** Keep the counter / active-thumb highlight in sync with the main swiper. */
  onSlideChange(e: any): void {
    const swiper = Array.isArray(e) ? e[0] : e;
    this.activeIndex = swiper?.realIndex ?? swiper?.activeIndex ?? 0;
  }

  slideNext(): void {
    this.swiperMain?.swiperRef?.slideNext(300);
  }

  slidePrev(): void {
    this.swiperMain?.swiperRef?.slidePrev(300);
  }

  goToSlide(i: number): void {
    this.swiperMain?.swiperRef?.slideToLoop(i, 300);
  }
}